import React from "react"
import "../css/about.css"

export default function About()
{
    return (
        <div className="about">
            <h2>about</h2>
            <p>I am a Software engineering student with a particular interest in Programming. I have a good grasp of front-end web development too, ranging from designing in Figma to making full-fledged projects in ReactJS. In the end, I am always looking for new things to learn.</p>
        </div>
    )
}
